import React, { Component } from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Redirect } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import ReadAloud from "components/Question/Speaking/ReadAloud.jsx";
import DescribeImage from "components/Question/Speaking/DescribeImage.jsx";
import RepeatSentece from "components/Question/Speaking/RepeatSentece.jsx";
import RetellLec from "components/Question/Speaking/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/ShortQue.jsx";
import Summary from "components/Question/Writting/Summary.jsx";
import Essay from "components/Question/Writting/Essay.jsx";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
import SingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder1.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import WrittingBlank from "components/Question/Reading/WrittingBlank.jsx";
import Summer from "components/Question/Listening/Summer.jsx";
import McqSingle from "components/Question/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import ResourceCheck from "./ResourceCheck.jsx";
// core components
import style from "components/test.css";
import { NavLink } from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import API from "api.js";
import { store } from "store/index";
import { setAlert } from "action/index.js";

import MockTimer from 'components/Timer/MockTimer.jsx';
import ConnectedRequest from 'components/ConnectedRequest/ConnectedRequest';

class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData: [],
      currentQuestion: 0,
      isRecording: false,
      blobURL: "",
      isBlocked: false,
      type: "",
      result: {
        strategy: 1
      },
      finalResult: [],
      lastFlag: true,
      resultId: false,
      secondCount: 0,
      submitProcess: false,
      saveProcess: false,
      dashboardFlag: false,
      resourceTested: false,
      mockCat: false,
      mockTime: 20,
      title: "",
      modal: false,
      pending: 0,
      msg: "",
      nextType: 0,
      qTime: 0,
      stopRecording: false,
      soundStat: true,
      soundModal: false,
      soundArr: [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20],
      q_count: 0,
      timeOutFlag: false,
      all_ok: false,
      ids: [],
      complete: 0,
			failed: [],
      intervalId: null,
      stopTimer: false,
      getTimeFromTimer: false,
      responseObj: {},
      internet: true
    };
  }
  /*2,4,5,13,14,15,16,17,18,19,20*/
  componentDidMount() {

    window.addEventListener("beforeunload", this.onUnloadListener);
    let isChrome =
      /Chrome/.test(navigator.userAgent) &&
      /Google Inc/.test(navigator.vendor) &&
      !/Chromium/.test(navigator.userAgent);
    let all_ok = isChrome ? true : false;
    navigator.getUserMedia(
      { audio: true },
      () => {
        console.log("Permission Granted");
        this.setState({ all_ok: all_ok });
      },
      () => {
        console.log("Permission Denied");
      }
    );
    document.body.classList.toggle("sidebar-mini");
    //document.querySelector('#minimizeSidebar').style.display = "none"
    API({
      method: "GET",
      url:
        "question/detail/" +
        this.props.match.params.id +
        "/" +
        this.props.match.params.pending,
    })
      .then((data) => {
        console.log(data.data);
        let to_pending = false;
        let to_begin = false;
        if (
          parseInt(this.props.match.params.pending) === 0 &&
          data.data.resume == true
        ) {
          to_pending = true;
        } else if (
          parseInt(this.props.match.params.pending) === 1 &&
          data.data.resume == false
        ) {
          to_begin = true;
        }

        this.setState(
          {
            mock_already_complete: data.data.complete === 1 ? true : false,
            check_ok: true,
            redirect_to_pending: to_pending,
            redirect_to_begin: to_begin,
          },
          () => {
            /**
            * Providing question Count. Sequencing for result.
            */
            let seq = parseInt(this.props.match.params.pending) === 0 ? 1 : (data.data.q_count + 1);
            data.data.mock.question.map((v) => {
              v.question_number = seq;
              seq++;
            });

            this.setState({
              ids: data.data.mock.question,
              title: data.data.mock.title,
              mockCat: data.data.mock.category,
              questionData: data.data.mock.question,
              type: data.data.mock.question[0].subcategory_id,
            });
            var intervalId = setInterval(this.timer, 1000);
            let soundStat = true;
            if (
              this.state.soundArr.includes(
                data.data.mock.question[0].subcategory_id
              )
            ) {
              soundStat = false;
            }
            this.setState({
              q_count: data.data.q_count,
              soundStat: soundStat,
              intervalId: intervalId,
              secondCount: parseFloat(data.data.time) * 60,
              mockTime: parseFloat(data.data.time) * 60,
            });
          }
        );
      })
      .catch(() => {});
    navigator.getUserMedia(
      { audio: true },
      () => {
        console.log("Permission Granted");
        this.setState({ isBlocked: false });
      },
      () => {
        console.log("Permission Denied");
        this.setState({ isBlocked: true });
      }
    );
    return () =>
      window.removeEventListener("beforeunload", this.onUnloadListener);
  }

  submitResponse = (data, f = false) => {
    let obj = {
      data: data.data,
      text_answer: data.answer,
      length: data.length,
      correct: data.correct,
      strategy: this.state.result.strategy
    };
    if (f) {
    } else {
      this.setState({ result: obj });
    }
  };

  resultStatus = () => {
    this.setState({ is_result: true });
  };

  timer = () => {
    let connection;
    if(typeof store.getState().intStatus === undefined || typeof store.getState().intStatus === "undefined") {
      connection = true;
    } else {
      connection = store.getState().intStatus;
    }

    if(connection) {
      if(!this.state.internet) {
        this.setState({internet: true});
      }

      if (this.state.secondCount === 1) {
        this.setState({ dashboardFlag: true, timeOutFlag: true });
        let bodyFormData = new FormData();
        this.setState({
          stopRecording: true,
          pending: 1,
          nextType: 1,
          complete: 1,
        });
        bodyFormData.append("mock_id", this.props.match.params.id);

        this.state.ids.map((v, k) => {
          if (k !== 0) {
            bodyFormData.append("id[]", `${v.id}-${v.question_number}`);
          }
        });
        API({
          method: "Post",
          url: "set/mockTime",
          data: bodyFormData,
        }).then((data) => {});
        clearInterval(this.state.intervalId);
      }
      this.setState({
        secondCount: this.state.secondCount - 1,
        qTime: this.state.qTime + 1,
      });
    } else {
      if(this.state.internet) {
        this.setState({internet: false});
      }
    }
  };

  componentWillUnmount = () => {
    this.submitFailed();
    document.body.classList.toggle("sidebar-mini");
    //document.querySelector('#minimizeSidebar').style.display = "block"
    clearInterval(this.state.intervalId);

    window.removeEventListener("beforeunload", this.onUnloadListener);
  };

  onUnloadListener(event) {
    event.preventDefault();
    event.returnValue = "";
    return "";
  }

  nextButton = (e, p) => {
    if (!this.state.soundStat) {
      this.setState({ soundModal: true });
    } else {
      let pending = 0;
      let msg = "";
      let complete = 0;
      let stopTimer = false;
      if (p === 0) {
        pending = 0;
        msg = "Do you want to go to next Question?";
      } else if (p === 1) {
        pending = 0;
        msg = "Do you want to submit test?";
        complete = 1;
        stopTimer = true;
      } else if (p === 2) {
        msg = "Do you want to save this question and exit mock test?";
        pending = 1;
      }
      this.setState({
        modal: true,
        pending: pending,
        msg: msg,
        nextType: p,
        complete: complete,
        stopTimer
      });
    }
  };

  toggleYes = () => {
    let check_if_exit_pending = this.state.pending;
    let check_if_exit_message = this.state.msg;
    if (check_if_exit_pending === 0 || check_if_exit_pending === 1) {
      if (
        check_if_exit_message === "Do you want to submit test?" ||
        check_if_exit_message ===
          "Do you want to save this question and exit mock test?"
      ) {
        clearInterval(this.state.intervalId);
      }
    }
    this.setState({
      stopRecording: true,
    });
  };

  nextQuestion = async (obj) => {

    // this.setState({
    //   getTimeFromTimer: true,
    //   responseObj: obj,
    //   modal: false,
    //   stopRecording: false
    // }, () => {
    //   // collect time data in CollectTimeAndProceed Func and proceed in that Func.
    // });
    
    let obj2 = {
      data: obj.data,
      text_answer: obj.answer,
      length: obj.length,
      correct: obj.correct,
      second: obj.time,
      lang: obj.lang,
      html: obj.html,
      audio_text: obj.audio_text,
      duration: obj.duration,
      strategy: this.state.result.strategy,
    };
    
    let obj1 = await this.finalObjectCreation(obj2);
    
    this.finalSubmit(obj1);
    if (this.state.nextType === 1 || this.state.nextType === 2) {
      this.submitFailed();
      this.setState({
        stopRecording: false,
        modal: false,
        dashboardFlag: true,
      });
      store.dispatch(
        setAlert({
          flag: true,
          type: 1,
          message: "Mock submitted successfully",
        })
      );
    } else {
      let soundStat = true;
      if (
        this.state.soundArr.includes(
          this.state.questionData[this.state.currentQuestion + 1].subcategory_id
        )
      ) {
        soundStat = false;
      }

      let currentStrategy = this.state.result.strategy;
      this.setState({
        soundStat: soundStat,
        stopRecording: false,
        result: {
          strategy: currentStrategy
        },
        currentQuestion: this.state.currentQuestion + 1,
        type: this.state.questionData[this.state.currentQuestion + 1].subcategory_id,
        modal: false,
      }, () => {
          this.forceUpdate();
      });
    }
  };

  finalSubmit = (obj1, timeRem=0, timeSpent=0) => {
    const { questionData, currentQuestion, secondCount, complete } = this.state;
    
    let curr = questionData[currentQuestion];
    // let time = timeRem;
    let time = this.state.secondCount;
    
    let finalArr = [];
    let obj = [];
    obj.push(obj1);

    const pending = parseInt(this.props.match.params.pending);
    const mock_id = this.props.match.params.id;

    /*if(this.state.lastFlag){
      finalArr = [...this.state.finalResult,obj];
      this.setState({finalResult:[...this.state.finalResult,obj],lastFlag:false})
    }else{
      finalArr = this.state.finalResult;
    }*/
    let bodyFormData = new FormData();
    if (pending === 1) {
      bodyFormData.append("result_id", mock_id);
    }

    bodyFormData.append("q_count", questionData.length); // total number of questions in test.
    bodyFormData.append("mock_id", mock_id); // mock id of test
    // bodyFormData.append("q_time", timeSpent); // time spent on question.
    bodyFormData.append("q_time", this.state.qTime); // time spent on question.
    bodyFormData.append("pending", this.state.pending); // mock pending status.
    bodyFormData.append("curr_q", 0); // current question flag
    bodyFormData.append("complete", complete); // complete flag.
    bodyFormData.append('question_number', curr.question_number);
    
    obj.map((v, k) => {
      
      if ([6, 7, 13].includes(v.type)) {
        time = time < 1 ? 1 : (time - v.second);
        // time = (time - v.second);
        // if (time < 1) {
        //   time = 1;
        // }
      }

      bodyFormData.append("time", time);
      bodyFormData.append("response[]", v.response);
      bodyFormData.append("text[]", v.answer);
      bodyFormData.append("lang[]", v.lang);
      bodyFormData.append("selected[]", v.text_answer);
      bodyFormData.append("text_answer[]", v.text_answer);
      bodyFormData.append("q_ans[]", v.q_ans);
      bodyFormData.append("length[]", v.length);
      bodyFormData.append("ans[]", v.q_ans);
      bodyFormData.append("html[]", v.html);
      bodyFormData.append("audio_text[]", v.audio_text);
      bodyFormData.append("type[]", v.type);
      bodyFormData.append("correct[]", v.correct);
      bodyFormData.append("script[]", v.script);
      bodyFormData.append("id[]", v.id);
      bodyFormData.append("duration[]", v.duration);
      
      if ([1, 2, 3, 4, 5].includes(v.type)) {
        bodyFormData.append("answer[]", v.ans);
        if (v.data === "" || v.data === undefined) {
          bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
        } else {
          bodyFormData.append("file[]", v.data);
        }

        // Add strategy only for read-aloud.
        if (parseInt(v.type) === 1) {
          bodyFormData.set('strategy', v.strategy);
        }
      } else if ([6, 7].includes(v.type)) {
        bodyFormData.append("answer[]", v.q_ans);
        bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
      } else if ([8, 9, 10, 11, 12].includes(v.type)) {
        bodyFormData.append("answer[]", v.correct);
        bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
      } else if ([13, 14, 15, 17, 19, 20, 18, 16].includes(v.type)) {
        bodyFormData.append("answer[]", v.correct);
        bodyFormData.append("file[]", new Blob(["hello worlppppppppppppd"]));
      }
    });
    // console.table([...bodyFormData]);
    /*if (flag) {
        this.setState({saveProcess:true});
        bodyFormData.append('pending', 1);
      }else{
        this.setState({submitProcess:true});
        bodyFormData.append('pending', 0);
      }*/

    API({
      method: "POST",
      url: "submit/mock",
      data: bodyFormData,
    }).then((data) => {
      let filteredAry = this.state.ids.filter(function (e) {
        return e.id !== obj[0].id;
      });
      this.setState({ secondCount: time, qTime: 0, ids: filteredAry });
      console.log(data);
      if (data.status === 200 && data.data.status === 200) {
        /*if (flag) {
            this.setState({submitProcess:false,dashboardFlag:true});  
          }else{
            this.setState({'resultId':data.data.id,submitProcess:false});
          }*/
        // store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));
      } else {
        this.setState({ submitProcess: false });
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
      }
    }).catch(() => {
      let arr = [];
      arr = this.state.failed;
      arr.push(bodyFormData);
      this.setState({failed: arr});
    });
  };

  submitFailed = () => {
	  let data = [];
	  let formData = new FormData();
	  this.state.failed.forEach((value, index) => {
		let object = {};
		// value.forEach((value, key) => console.log(key , value));
		value.forEach((value, key) => {
			if(key === 'file[]') {
				formData.append('files[]', value)
			} else {
				object[key] = value;
				formData.append(`data[${index}][${key}]`, value)
			}
		});
		data.push(object);
	  })
	  setTimeout(() => {
		API({
		method: "POST",
		url: "submitFailed/mock",
		data: formData,
		})
		.then(() => {})
		.catch(() => {});
	  }, 2000)
	}

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  soundChecked = () => {
    this.setState({ soundStat: true });
  };

  showTest = () => {
    this.setState({ resourceTested: true, secondCount: this.state.mockTime });
    this.forceUpdate();
  };

  closeSoundModal = () => {
    this.setState({ soundModal: false });
  };

  closeTimeoutModal = () => {
    this.setState({ timeOutFlag: false });
  };

  finalObjectCreation = (obj1 = false) => {
    const { questionData, currentQuestion, result } = this.state;

    let qdata = questionData[currentQuestion];
    let response = true;
    if (Object.keys(result).length === 0) {
      response = true;
    }
    let obj = {};
    if (obj1) {
      obj = {
        ...obj1,
        type: qdata.subcategory_id,
        id: qdata.id,
        response: response,
        answer: qdata.question,
        script: qdata.audio_script,
        q_ans: qdata.answer,
      };
    } else {
      obj = {
        ...result,
        type: qdata.subcategory_id,
        id: qdata.id,
        response: response,
        answer: qdata.question,
        script: qdata.audio_script,
        q_ans: qdata.answer,
      };
    }
    return obj;
  };


  setIntervalId = (interval_id) => {
    this.setState({ intervalId: interval_id });
  }

  setStopTimer = (v) => {
    this.setState({ stopTimer: v });
  }

  setGetTimerTime = (v, timeRem, timeSpent) => {
    this.setState({ getTimeFromTimer: v }, () => {
      // this.CollectTimeAndProceed(timeRem, timeSpent);
    });
  }

  CollectTimeAndProceed = async (timeRem, timeSpent) => {
    const { secondCount, responseObj, nextType } = this.state;
    let obj2 = {
      data: responseObj.data,
      text_answer: responseObj.answer,
      length: responseObj.length,
      correct: responseObj.correct,
      second: responseObj.time,
      lang: responseObj.lang,
      html: responseObj.html,
      audio_text: responseObj.audio_text,
      duration: responseObj.duration,
    };


    // Final Submit.
    let obj1 = await this.finalObjectCreation(obj2);
    this.finalSubmit(obj1, timeRem, timeSpent);
    

    // showing next question
    if (nextType === 1 || nextType === 2) {
      this.submitFailed();
      this.setState({
        dashboardFlag: true,
      });
      store.dispatch(
        setAlert({
          flag: true,
          type: 1,
          message: "Mock submitted successfully",
        })
      );
    } else {
      const { soundArr, questionData, currentQuestion } = this.state;
      let soundStat = true;
      if (soundArr.includes(questionData[currentQuestion + 1].subcategory_id)) {
        soundStat = false;
      }
      this.setState({
        soundStat: soundStat,
        result: {
          strategy: this.state.result.strategy
        },
        currentQuestion: currentQuestion + 1,
        type: questionData[currentQuestion + 1].subcategory_id,
      }, () => {
        this.forceUpdate();
      });
    }
  }

  setStrategy = (st) => {
    const r = this.state.result;
    r.strategy = st;
    this.setState({
      result: r
    });
  }

  render() {
    
    let props = {
      submit: this.submitResponse,
      showResult: this.resultStatus,
      data: this.state.questionData[this.state.currentQuestion],
      resultMode: false,
      testMode: true,
      soundChecked: this.soundChecked,
      stopRecording: this.state.stopRecording,
      nextQuestion: this.nextQuestion,
      strategy: this.state.result.strategy,
      setStrategy: this.setStrategy
    };
    
    let que;
    let title = "";
    let ques_title = "";
    if (this.state.questionData.length > 0) {
      ques_title = this.state.questionData[this.state.currentQuestion].q_title;
    }

    let { redirect_to_pending, redirect_to_begin, mock_already_complete, currentQuestion } =
      this.state;

    switch (this.state.type) {
      case 1:
        que = <ReadAloud {...props} key={currentQuestion} />;
        title =
          "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
        break;
      case 2:
        que = <RepeatSentece {...props} key={currentQuestion} />;
        title =
          "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
        break;
      case 3:
        que = <DescribeImage {...props} key={currentQuestion} />;
        title =
          "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
        break;
      case 4:
        que = <RetellLec {...props} key={currentQuestion} />;
        title =
          "Listen to and read a description of a situation. You will have 20 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
        break;
      case 5:
        que = <ShortQue {...props} key={currentQuestion} />;
        title =
          "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
        break;
      case 6:
        que = <Summary {...props} key={currentQuestion} />;
        title =
          "Read the passage below. Summarize the passage using between 25 and 50 words. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage.";
        break;
      case 7:
        que = <Essay {...props} key={currentQuestion} />;
        title =
          "Read a description of a situation. Then write an email about the situation. You will have 9 minutes. You should aim to write at least 100 words.";
        break;
      case 8:
        que = <SingleAnswer {...props} key={currentQuestion} />;
        title =
          "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case 9:
        que = <MultipleAnswer {...props} key={currentQuestion} />;
        title =
          "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
        break;
      case 10:
        que = <Reorder {...props} key={currentQuestion} />;
        title =
          "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
        break;
      case 11:
        que = <ReadingBlank {...props} key={currentQuestion} />;
        title =
          "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
        break;
      case 12:
        que = <WrittingBlank {...props} key={currentQuestion} />;
        title =
          "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
        break;
      case 13:
        que = <Summer {...props} key={currentQuestion} />;
        title =
          "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 20-30 words. You have 8 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
        break;
      case 14:
        que = <McqSingle {...props} key={currentQuestion} />;
        title =
          "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case 15:
        que = <McqMulti {...props} key={currentQuestion} />;
        title =
          "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
        break;
      case 16:
        que = <ListeningBlank {...props} key={currentQuestion} />;
        title =
          "You will hear a recording. Type the missing words in each blank.";
        break;
      case 17:
        que = <CorrectSummary {...props} key={currentQuestion} />;
        title =
          "You will hear a recording. Click on the paragraph that best relates to the recording.";
        break;
      case 18:
        que = <MissingWord {...props} key={currentQuestion} />;
        title =
          "You will hear a recording about " +
          ques_title +
          ". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
        break;
      case 19:
        que = <Highlight {...props} key={currentQuestion} />;
        title =
          "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
        break;
      case 20:
        que = <Dictation {...props} key={currentQuestion} />;
        title =
          "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
        break;
      default:
      // code block
    }


    /*
    * Timer settings.
    */
    // let timerSettings = {
    //   secondCount: this.state.secondCount,
    //   setIntervalId: this.setIntervalId,
    //   stopTimer: this.state.stopTimer,
    //   setStopTimer: this.setStopTimer,
    //   getTimeFromTimer: this.state.getTimeFromTimer,
    //   setGetTimerTime: this.setGetTimerTime
    // };

    return (
      <>
        {!mock_already_complete && redirect_to_pending && (
          <div className="content questionsArea mock-already-completed">
            <Row>
              <Col xs={12}>
                <CardBody>
                  <Row className="testFinish unselectable">
                    <div className="col-sm-12">
                      <p>
                        <span>
                          This mock is unfinished. Please{" "}
                          <a
                            href={`/admin/test/${this.props.match.params.id}/1`}
                          >
                            <Button color="primary" size="xs">
                              Click here
                            </Button>
                          </a>{" "}
                          to resume this test.
                        </span>
                      </p>
                    </div>
                  </Row>
                </CardBody>
              </Col>
            </Row>
          </div>
        )}
        
        {!mock_already_complete && redirect_to_begin && (
          <div className="content questionsArea mock-already-completed">
            <Row>
              <Col xs={12}>
                <CardBody>
                  <Row className="testFinish unselectable">
                    <div className="col-sm-12">
                      <p>
                        <span>
                          You can't resume this mock.{" "}
                          <a
                            href={`/admin/test/${this.props.match.params.id}/0`}
                          >
                            <Button color="primary" size="xs">
                              Click here
                            </Button>
                          </a>{" "}
                          to begin this test.
                        </span>
                      </p>
                    </div>
                  </Row>
                </CardBody>
              </Col>
            </Row>
          </div>
        )}
        
        {mock_already_complete === true && (
          <div className="content questionsArea mock-already-completed">
            <Row>
              <Col xs={12}>
                <CardHeader>
                  <Row>
                    <Col xs={12}>
                      <CardTitle tag="h4">{this.state.title}</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row className="testFinish unselectable">
                    <div className="col-sm-12">
                      <p>
                        <span>
                          Dear user, you've already <strong>FINISHED</strong>{" "}
                          this mock. Please attempt some other mock.
                        </span>
                      </p>
                    </div>
                  </Row>
                </CardBody>
              </Col>
            </Row>
          </div>
        )}
        
        {!this.state.all_ok && <ChromeCheck />}
        
        {this.state.all_ok && (
          <>
            {this.state.timeOutFlag && (
              <Modal isOpen={this.state.timeOutFlag} size="sm">
                <ModalBody>
                  <div>Test stopped due to timeout.</div>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    className="modalCloseBtn"
                    onClick={this.closeTimeoutModal}
                  >
                    OK
                  </Button>
                </ModalFooter>
              </Modal>
            )}
            {this.state.soundModal && (
              <Modal isOpen={this.state.soundModal} size="sm">
                <ModalBody>
                  <div>Please wait for question audio to be finished.</div>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    className="modalCloseBtn"
                    onClick={this.closeSoundModal}
                  >
                    OK
                  </Button>
                </ModalFooter>
              </Modal>
            )}
            {this.state.modal && (
              <Modal isOpen={this.state.modal} size="sm">
                <ModalBody>
                  <div>{this.state.msg}</div>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    className="modalCloseBtn"
                    onClick={this.toggleYes}
                  >
                    Yes
                  </Button>
                  <Button
                    color="secondary"
                    className="modalCloseBtn"
                    onClick={this.toggle}
                  >
                    No
                  </Button>
                </ModalFooter>
              </Modal>
            )}
            {this.state.mockCat && !this.state.resourceTested && (
              <ResourceCheck
                showTest={this.showTest}
                pending={0}
                data={{}}
                cat={this.state.mockCat}
              />
            )}

            {this.state.resourceTested && (
              <div className="content questionsArea">
                <Row>
                  <Col xs={12}>
                    <Card>
                      <CardHeader>
                        <Row>
                          <Col xs={6}>
                            <CardTitle tag="h4">{this.state.title}</CardTitle>
                          </Col>
                          <Col xs={6}>
                            <div className="text-right questionTime">
                              {<div className="timeRemaining">
                                <p>
                                  <i class="fa fa-clock-o"></i>{" "}
                                  <span>
                                    Time Remaining:{" "}
                                    {Math.floor(this.state.secondCount / 60) +
                                      ":" +
                                      parseInt(this.state.secondCount % 60)}
                                  </span>
                                </p>
                              </div>}
                              {/*<MockTimer {...timerSettings} />*/}
                              <div className="item">
                                <p>
                                  Question{" "}
                                  {this.state.currentQuestion +
                                    this.state.q_count +
                                    1}{" "}
                                  of{" "}
                                  {this.state.questionData.length +
                                    this.state.q_count}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody>
                        <b>{title}</b>
                        <Row className="unselectable">
                          {this.state.secondCount === 0 && (
                            <div>Time up please restart the Test</div>
                          )}
                          {this.state.internet
                            ? this.state.secondCount !== 0 && this.state.questionData && que
                            : <>
                              <Skeleton count={1} width={"50%"} height={200} containerClassName="skeleton-wrapper__mockrecording" />
                              <Skeleton count={5} width={"100%"} containerClassName="skeleton-wrapper__mocklines" />
                            </>
                          }
                          {/*this.state.secondCount !== 0 && this.state.questionData && que*/}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={12}>
                    <div className="bottomBtns">
                      <Row>
                        <Col xs={9}>
                          {!this.state.dashboardFlag &&
                            !this.state.saveProcess &&
                            !this.state.resultId &&
                            this.state.currentQuestion > 0 &&
                            this.state.questionData.length !==
                              this.state.currentQuestion + 1 && (
                              <Button
                                color="primary"
                                onClick={(e) => this.nextButton(e, 2)}
                                size="xs"
                              >
                                Save & Exit
                              </Button>
                            )}
                          {this.state.saveProcess &&
                            !(
                              this.state.questionData.length !=
                              this.state.currentQuestion + 1
                            ) && (
                              <Button color="primary" size="xs">
                                Wait...
                              </Button>
                            )}
                          {!this.state.dashboardFlag &&
                            !this.state.submitProcess &&
                            this.state.secondCount !== 0 &&
                            !this.state.resultId &&
                            !(
                              this.state.questionData.length !=
                              this.state.currentQuestion + 1
                            ) && (
                              <Button
                                color="primary"
                                onClick={(e) => this.nextButton(e, 1)}
                                size="xs"
                              >
                                Submit
                              </Button>
                            )}
                          {this.state.submitProcess &&
                            !(
                              this.state.questionData.length !=
                              this.state.currentQuestion + 1
                            ) && (
                              <Button color="primary" size="xs">
                                Wait...
                              </Button>
                            )}

                          {this.state.submitProcess &&
                            !(
                              this.state.questionData.length !=
                              this.state.currentQuestion + 1
                            ) && (
                              <Button color="primary" size="xs">
                                Wait...
                              </Button>
                            )}
                          {this.state.resultId && (
                            <NavLink
                              to={"/admin/result/" + this.state.resultId}
                            >
                              {" "}
                              <Button color="primary" size="xs">
                                Show Result
                              </Button>{" "}
                            </NavLink>
                          )}
                          {this.state.dashboardFlag && (
                            <NavLink to={"/admin/dashboard"}>
                              {" "}
                              <Button color="primary" size="xs">
                                Go to Dashboard
                              </Button>{" "}
                            </NavLink>
                          )}
                          {this.state.timeOutFlag && (
                            <div>Test stopped due to timeout</div>
                          )}
                        </Col>
                        <Col xs={3}>
                          {!this.state.dashboardFlag &&
                            this.state.secondCount !== 0 &&
                            !this.state.resultId &&
                            this.state.questionData.length !=
                              this.state.currentQuestion + 1 &&
                            this.state.questionData.length !== 0 && (
                              <Button
                                color="primary"
                                onClick={(e) => this.nextButton(e, 0)}
                                size="xs"
                              >
                                NEXT
                              </Button>
                            )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </>
        )}

        {this.state.questionData.length > 0 &&
          <ConnectedRequest
            question_type={this.state.questionData[currentQuestion].subcategory_id}
          />
        }
      </>
    );
  }
}

export default Test;
